import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[mxNumericOnly]'
})
export class NumericInputOnlyDirective {
  @Input() public integerOnly = false;
  private readonly navigationKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End',
    'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste'
  ];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const isCtrlOrMetaKeyHeld: boolean = event.ctrlKey || event.metaKey;
    const allowedComboKeys: string[] = ['a', 'c', 'v'];

    // Allow common key combos
    if (
      this.navigationKeys.indexOf(event.key) > -1 || // Navigation keypress
      (isCtrlOrMetaKeyHeld && allowedComboKeys.includes(event.key)) // Copy, Paste, Select All, etc
    ) return;

    // Allow digits always, decimal point only if not integer-only
    const isDigit = /^\d$/.test(event.key);
    const isDecimalPoint = event.key === '.' && !this.integerOnly;
    if (!isDigit && !isDecimalPoint) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const isValidNumber = this.integerOnly ? /^\d+$/.test(clipboardData) : /^\d*\.?\d*$/.test(clipboardData);
    if (!isValidNumber) {
      event.preventDefault();
    }
  }
}
